const productCategories = [
    {
        name: "GMV Outdoor",
        category: "Outdoor",
    },
    {
        name: "GMV Indoor",
        category: "Indoor",
    },
    {
        name: "R32 GMV Outdoor",
        category: "R32 GMV Outdoor",
    },
    {
        name: "R32 GMV Indoor",
        category: "R32 GMV Indoor",
    },
    {
        name: "GMV AHU Kits & Mode Exch",
        category: "AHU Kits & Mode Exch",
    },
    {
        name: "GMV Controls",
        category: "Controls",
    },
    {
        name: "Mini Split Controls",
        category: "Mini Split Controls",
    },
    {
        name: "GMV Copper",
        category: "Copper",
    },
    {
        name: "R410a Mini Splits",
        category: "Mini Split",
    },
    {
        name: "R32 Mini Splits",
        category: "R32 Mini Split",
    }
]

const equipmentSummary = [
    {
        name: "GMV Outdoor",
        category: "Outdoor",
        price: 0,
    },
    {
        name: "GMV Indoor",
        category: "Indoor",
        price: 0,
    },
    {
        name: "R32 GMV Outdoor",
        category: "R32 GMV Outdoor",
        price: 0,
    },
    {
        name: "R32 GMV Indoor",
        category: "R32 GMV Indoor",
        price: 0,
    },
    {
        name: "AHU Kits & Mode Exch",
        category: "AHU Kits & Mode Exch",
        price: 0,
    },
    {
        name: "Controls",
        category: "Controls",
        price: 0,
    },
    {
        name: "Mini Split Controls",
        category: "Mini Split Controls",
        price: 0,
    },
    {
        name: "Copper",
        category: "Copper",
        price: 0,
    },
    {
        name: "Mini Splits",
        category: "Mini Split",
        price: 0,
    },
    {
        name: "R32 Mini Splits",
        category: "R32 Mini Split",
        price: 0,
    }
]

const equipmentSummaryMap = {
    "Outdoor Equipment": "GMV Outdoor",
    "Indoor Equipment": "GMV Indoor",
    "GMV Outdoor": "GMV Outdoor",
    "GMV Indoor": "GMV Indoor",
    "R32 GMV Outdoor": "R32 GMV Outdoor",
    "R32 GMV Indoor": "R32 GMV Indoor",
    "AHU Kits & Mode Exch": "GMV AHU Kits & Mode Exch",
    "Controls": "GMV Controls",
    "Mini Split Controls": "Mini Split Controls",
    "Copper": "GMV Copper",
    "Mini Splits": "R410a Mini Splits",
    "R32 Mini Splits": "R32 Mini Splits",
}

export {
    productCategories,
    equipmentSummary,
    equipmentSummaryMap
}